import type { Locale } from "@/modules/shared/localization/const/language";
import { getLocaleCookie } from "@/utils/cookies";

export const useLocale = (): Locale => {
  // this is needed instead of using useParams or useRouteContext
  // because of the auth callback route which is outside of the $locale folder
  const localeCookie = getLocaleCookie() as Locale | undefined;
  return localeCookie ?? "hr";
};
